import { Injectable } from '@angular/core';
import { Process } from './process';
import { HttpClient } from '@angular/common/http';
import { StorageUtils } from '../../../utils/storage-utils';
import { RestService } from '../../../utils/rest-service';
import { JsonContainer } from '../../../utils/json-container';
import { ProcessSearch } from './process-search';
import { ActivityLog } from '../../ok-activity-log/activity-log/activity-log';
import { Task } from '../../tasks/task/task';
export interface OnboardingData {
    date: string; // ou Date se você preferir lidar com objetos Date no frontend
    count: number;
}

interface AggregatedPlanData {
    category: string;
    count: number;
    simplesNacional: number;
    mei: number;
    lucroPresumido: number;
}

@Injectable()
export class ProcessService extends RestService {

    constructor(private client: HttpClient, private storageUtils: StorageUtils) {
        super(client, 'process', storageUtils);
    }

    search(search: ProcessSearch, callback: (result: JsonContainer, processes: Process[]) => void) {
        this.executePost('search', search, callback)
    }
    searchActiveCustomer(search: ProcessSearch, callback: (result: JsonContainer, processes: Process[]) => void) {
        this.executePost('searchActiveCustomer', search, callback)
    }

    save(process: Process, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut('save', process, callback)
    }

    loadByCompany(idCompany: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet('loadByCompany/' + idCompany, callback)
    }

    loadCustomerByCompany(idCompany: string, callback: (result: JsonContainer, customer: any) => void) {
        this.executeGet('loadCustomerByCompany/' + idCompany, callback)
    }

    loadByCompanyDoc(document: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet('loadByCompanyDoc/' + document, callback)
    }

    loadByCustomerEmail(email: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet('loadByCustomerEmail/' + email, callback)
    }

    load(id: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet('load/' + id, callback)
    }

    loadByUserId(id: string, callback: (result: JsonContainer, process: Process) => void) {
        this.executeGet('loadByUserId/' + id, callback)
    }

    deleteAttachment(id: string, destination: string, partnerIndex: number | -1, processId: String, callback: (result: JsonContainer, process: Process) => void) {
        this.executeDelete(`deleteAttachment/${id}/${destination}/${processId}/${partnerIndex}`, callback);
    }

    listActivityLogs(id: string, callback: (result: JsonContainer, logs: ActivityLog[]) => void) {
        this.executeGet('listActivityLogs/' + id, callback)
    }

    saveCommentTimeline(activity: ActivityLog, callback: (result: JsonContainer) => void) {
        this.executePut('saveCommentTimeline', activity, callback)
    }

    forward(task: Task, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut('forward', task, callback)
    }

    delegate(task: Task, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut('delegate', task, callback)
    }

    issueTestInvoice(id: string, callback: (result: JsonContainer) => void) {
        this.executeGet('issueTestInvoice/' + id, callback)
    }

    changeProcessDesc(processId: string, callback: (result: JsonContainer) => void) {
        this.executePost('changeProcessDesc', processId, callback)
    }
    cancelProcess(processId: string, callback: (result: JsonContainer) => void) {
        this.executeGet(`disableProcess/${processId}`, callback)
    }

    cancelProcessAuthorize(processId: string, callback: (result: JsonContainer) => void) {
        this.executeGet(`disableProcessAuthorize/${processId}`, callback)
    }

    authorize(process: Process, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut(`authorize`, process, callback)
    }

    companyAlreadyExists(emailUser: string, callback: (result: JsonContainer, exists: boolean) => void) {
        this.executeGet(`companyAlreadyExists/${emailUser}`, callback)
    }

    updateProcess(updatedProcess, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut(`updateProcess`, updatedProcess, callback);
    }

    saveChangeCounter(process: Process, callback: (result: JsonContainer, process: Process) => void) {
        this.executePut('saveChangeCounter', process, callback)
    }


    loadOnboarding(callback: (result: JsonContainer, resps: OnboardingData[]) => void) {
        this.executeGet('loadOnboardingByDay', (result: JsonContainer, resps: OnboardingData[]) => {
            callback(result, resps);
        });
    }

    loadClosedBlockedOnboarding(callback: (result: JsonContainer, resps: OnboardingData[]) => void) {
        this.executeGet('loadClosedBlockedOnboardingByDay', (result: JsonContainer, resps: OnboardingData[]) => {
            callback(result, resps);
        });
    }

    searchProcess(search: ProcessSearch, pageSize: number, callback: (result: JsonContainer, tasks: Process[]) => void) {
        const url = `search?pageSize=${pageSize}`;
        this.executePost(url, search, callback);
    }

    loadOnboardingByPlan(planCode: string, callback: (result: JsonContainer, resps: Record<string, number>) => void) {
        const url = `loadOnboardingByPlan?code=${planCode}`;
        this.executeGet(url, (result: JsonContainer, resps: Record<string, number>) => {
            callback(result, resps);
        });
    }

    loadAggregatedPlans(callback: (result: JsonContainer, resps: AggregatedPlanData[]) => void) {
        this.executeGet('aggregatePlans', (result: JsonContainer, resps: AggregatedPlanData[]) => {
            callback(result, resps);
        });
    }

    loadInactiveDataByMonth(callback: (result: JsonContainer, resps: Process) => void) {
        this.executeGet('loadInactiveDataByMonth', (result: JsonContainer, resps: Process) => {
            callback(result, resps);
        });
    }

    sendAccountingMigration(companyId: String,  callback: (result: JsonContainer, email) => void) {
        this.executePost('sendEmailAccountMigration', companyId, callback)
    }

    sendEmailCertificate(companyId: String,  callback: (result: JsonContainer, email) => void) {
        this.executePost('sendEmailCertificate', companyId, callback)
    }

    checkSigtnature(id: String,  callback: (result: JsonContainer, email) => void) {
        this.executePost('checkSigtnature', id, callback)
    }

}
